// // dashboard-frontend/src/api.js
// export const API_BASE = process.env.REACT_APP_API_URL || 'https://api.shreekanaksuriahinsadham.com';

// export async function fetchJSON(url, options = {}) {
//   const token = localStorage.getItem('token');
//   const headers = options.headers || {};
//   if (token && !headers['Authorization']) {
//     headers['Authorization'] = `Bearer ${token}`;
//   }
//   options.headers = headers;
//   const res = await fetch(API_BASE + url, options);
//   const data = await res.json();
//   if (!res.ok) {
//     throw new Error(data.error || 'Request failed');
//   }
//   return data;
// }



// dashboard-frontend/src/api.js

// If you want local dev, set REACT_APP_API_URL=http://localhost:8080 in .env
export const API_BASE = process.env.REACT_APP_API_URL || 'https://api.shreekanaksuriahinsadham.com';

/**
 * fetchJSON - helper for making fetch calls, automatically sets the Authorization header
 * if a token is in localStorage under key 'token'.
 */
export async function fetchJSON(url, options = {}) {
  // Retrieve the token from localStorage
  const token = localStorage.getItem('token');

  // Set up headers
  const headers = options.headers || {};
  if (token && !headers['Authorization']) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  options.headers = headers;

  // Make the request
  const res = await fetch(API_BASE + url, options);
  const data = await res.json();

  // If response is not OK, throw an error
  if (!res.ok) {
    throw new Error(data.error || 'Request failed');
  }
  return data;
}

export const submitCashDonation = async (donationData) => {
  return await fetchJSON('/api/users/cash-donation', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(donationData),
  });
};

export async function verifyOnlineDonation(paymentData) {
  return await fetchJSON('/api/verify-payment', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(paymentData),
  });
}

export const acknowledgeDeposit = async (donationId, depositNote, upiTransactionId, bankName, chequeNumber) => {
  try {
    const response = await fetchJSON(`/api/users/cash-donation/${donationId}/acknowledge`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        depositNote, 
        upiTransactionId,
        bankName,
        chequeNumber
      }),
    });
    return response;
  } catch (error) {
    console.error('Error acknowledging deposit:', error.message);
    throw error;
  }
};
